const sortForSignature = (value) => {
  if (Array.isArray(value)) {
    return value.map(sortForSignature);
  }

  if (value && Object.getPrototypeOf(value) === Object.prototype) {
    return Object.keys(value)
      .sort()
      .reduce((sorted, key) => {
        sorted[key] = sortForSignature(value[key]);
        return sorted;
      }, {});
  }

  return value;
};

export const createRequestSignature = (request) =>
  JSON.stringify(sortForSignature(request));

export const createInFlightRequestDeduplicator = () => {
  const inFlightRequests = new Map();

  return (signature, requestFactory) => {
    const currentRequest = inFlightRequests.get(signature);
    if (currentRequest) return currentRequest;

    const request = Promise.resolve().then(requestFactory);
    const trackedRequest = request.then(
      (result) => {
        if (inFlightRequests.get(signature) === trackedRequest) {
          inFlightRequests.delete(signature);
        }
        return result;
      },
      (error) => {
        if (inFlightRequests.get(signature) === trackedRequest) {
          inFlightRequests.delete(signature);
        }
        throw error;
      }
    );

    inFlightRequests.set(signature, trackedRequest);
    return trackedRequest;
  };
};
